"use strict";

var _classCallCheck = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/michael/Documents/michaelw54.github.io/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Main = void 0;

var main_slim_1 = require("./main.slim");

var AbsorbersPlugin_1 = require("./Plugins/Absorbers/AbsorbersPlugin");

var EmittersPlugin_1 = require("./Plugins/Emitters/EmittersPlugin");

var PolygonMaskPlugin_1 = require("./Plugins/PolygonMask/PolygonMaskPlugin");

var Main = /*#__PURE__*/function (_main_slim_1$MainSlim) {
  _inherits(Main, _main_slim_1$MainSlim);

  var _super = _createSuper(Main);

  function Main() {
    var _this;

    _classCallCheck(this, Main);

    _this = _super.call(this);

    _this.addPlugin(AbsorbersPlugin_1.AbsorbersPlugin);

    _this.addPlugin(EmittersPlugin_1.EmittersPlugin);

    _this.addPlugin(PolygonMaskPlugin_1.PolygonMaskPlugin);

    return _this;
  }

  return Main;
}(main_slim_1.MainSlim);

exports.Main = Main;